// extracted by mini-css-extract-plugin
export default {"backdrop":"modal_backdrop__sjl+U","modal":"modal_modal__U-qdz","slide-down":"modal_slide-down__qRrdH"};